export default __webpack_public_path__ + "static/screen_lock_5-6b803851651065912065e3ec655a5628.png";